import React, { Suspense, useContext } from 'react'
import { Navigate, useLocation } from 'react-router'

import { ProfileContext } from '../contexts/ProfileContext'
import Layout from '../layouts'
import { isLogin } from '../utils/helper'
import TimeOut from '../utils/TimeOut'

interface PrivateRouteProps {
  children: React.ReactNode
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const location = useLocation()
  const { me } = useContext(ProfileContext)

  if (!isLogin()) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Redirect to profile if 2FA is required but not yet set up
  const requiresTwoFactorSetup = me?.twoFactorAuthRequired && !me?.twoFactorAuthSetupAt
  if (requiresTwoFactorSetup && location.pathname !== '/profile') {
    return <Navigate to="/profile?tab=security" replace />
  }

  // Render the layout and the protected content
  return (
    <Layout>
      <TimeOut />
      <Suspense fallback={<div>Loading...</div>}>{children}</Suspense>
    </Layout>
  )
}

export default PrivateRoute
